export default "__VITE_ASSET__e3a34c0c__"